(function () {
  if (window.__phCycle) return; window.__phCycle = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window) || !window.fetch) return;

  var INTERVAL = 4500;
  var css = '.card__media .media img.ph-cyc{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;opacity:0 !important;z-index:2;transform:scale(1.04);transition:opacity 1.6s ease,transform 6s ease}' +
    '.card__media .media img.ph-cyc.ph-on{opacity:1 !important;transform:scale(1)}' +
    '.ph-dots{position:absolute;left:10px;right:10px;bottom:10px;z-index:3;display:flex;gap:4px;pointer-events:none}' +
    '.ph-dots i{flex:1;height:3px;border-radius:3px;background:rgba(255,255,255,.45);overflow:hidden;position:relative}' +
    '.ph-dots i.ph-on::after{content:"";position:absolute;inset:0;background:#FFC93C;animation:ph-fill var(--ph-int,4500ms) linear forwards}' +
    '@keyframes ph-fill{from{transform:scaleX(0);transform-origin:left}to{transform:scaleX(1);transform-origin:left}}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  // supplier photos with text/diagrams: not shown in the card slideshow
  var HIDE = ["bb7f1df6-ac8f-4489-95b3-6d7f07368deb.jpg","4a15f15c-a2b8-47ed-bf82-381fae762ae1.jpg","2a5dcb33-4ddf-43e6-a7b8-a6c32dc474c3.jpg","faa29a07-d114-4fcd-93d5-de5387885dd6.jpg","0cad2d54-03f1-4c01-8c18-6b84807e57e3.jpg","7bd853f4-e414-4843-aaec-bf991bbdacc6.jpg","5caa9be7-4093-417a-92fb-dc94cd2b4bc0.jpg","b2f0f1e4-85ae-4280-a018-1dd955886f13.jpg","f2456e01-f5a0-442f-834a-002bac533cb3.jpg","729091aa787af1edbc339fa348cd1927.jpg","92f17d648c0b7d32fb3a1e423af2163d.jpg","d6261e7177a1655bb1c97a10f2a687bb.jpg","2177198792634.jpg","ca2656b02e83d691e6e56a57d7a3e0bc.jpg","3037942abc0fe9b6d28ad0778de233d4.jpg","ab79fd365e692970bb67bf0f7f2646f7.jpg","796a9e20-bb0f-4bb0-ba24-085ceb9874d6_fine.jpg","2c6d43a7-02c2-4489-8358-4ad0f16ad584_trans.jpg","47605bee-e1f7-42b6-a46d-77ba2c08d963_trans.jpg","c29aa982-8274-401f-9b48-135ba4074874_trans.jpg","dbe02818-c61b-4029-a067-a87ab611af85.png","2401120916070325100.jpg","2401120916070325700.jpg","2401120916070326400.jpg","1618974550535.jpg","6725c8e0-9ca8-49e6-88d0-d74f7e323431.jpg","2403190118120320300.jpg","2403190118120322900.jpg"];
  function okImg(u){ var f=u.split('?')[0].split('/').pop().toLowerCase(); return HIDE.indexOf(f)===-1; }
  var cache = {};
  function getImages(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { return p && p.images ? p.images.filter(okImg).slice(0, 5) : []; })
        .catch(function () { return []; });
    }
    return cache[handle];
  }
  function sized(url, w) {
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function setup(card, order) {
    if (card.dataset.phCyc) return; card.dataset.phCyc = '1';
    var link = card.querySelector('a[href*="/products/"]');
    var box = card.querySelector('.card__media .media');
    if (!link || !box) return;
    var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    if (!m) return;
    var handle = m[1];
    var state = { timer: null, idx: 0, imgs: [], dots: [], visible: false, ready: false };

    function show(i) {
      state.imgs.forEach(function (im, k) { im.classList.toggle('ph-on', k === i); });
      state.dots.forEach(function (d, k) { d.classList.remove('ph-on'); if (k === i) { void d.offsetWidth; d.classList.add('ph-on'); } });
    }
    function tick() { state.idx = (state.idx + 1) % state.imgs.length; show(state.idx); }
    function start() {
      if (!state.ready || state.timer || state.imgs.length < 2) return;
      state.timer = setTimeout(function first() {
        tick();
        state.timer = setInterval(tick, INTERVAL);
      }, 1500 + (order % 4) * 1100);
    }
    function stop() { if (state.timer) { clearTimeout(state.timer); clearInterval(state.timer); state.timer = null; } }

    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        state.visible = e.isIntersecting;
        if (e.isIntersecting && !state.ready && !state.loading) {
          state.loading = true;
          getImages(handle).then(function (urls) {
            if (urls.length < 2) return;
            var w = Math.min(900, Math.round(box.clientWidth * (window.devicePixelRatio || 1)) || 600);
            urls.forEach(function (u, k) {
              var im = new Image();
              im.className = 'ph-cyc' + (k === 0 ? ' ph-on' : '');
              im.alt = ''; im.loading = 'lazy'; im.decoding = 'async';
              im.src = sized(u, w);
              box.appendChild(im); state.imgs.push(im);
            });
            var dots = document.createElement('div'); dots.className = 'ph-dots'; dots.style.setProperty('--ph-int', INTERVAL + 'ms');
            urls.forEach(function () { var d = document.createElement('i'); dots.appendChild(d); state.dots.push(d); });
            box.appendChild(dots);
            state.ready = true; show(0);
            if (state.visible) start();
          });
        }
        if (e.isIntersecting) start(); else stop();
      });
    }, { threshold: 0.35 });
    io.observe(card);
  }

  function init() {
    document.querySelectorAll('main .card-wrapper').forEach(function (c, i) { setup(c, i); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
